import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Button } from "components/forms";

import { useActionHook, useModals } from "../../../hooks";
import { IDeleteModal } from "../../../store/types/modals";

import "./DeleteModal.styles.scss";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none"
};

export const DeleteModal: React.FC<{ data: IDeleteModal | null }> = ({ data }): JSX.Element => {
  const defaultAction = async () => undefined;
  const { closeDeleteModal } = useModals();
  const { Body, element, message, onPressSuccess, onPressCancel, action: initialAction, cancelAction } = data || {};

  const { action, loading } = useActionHook(initialAction || defaultAction, {
    onFinally: closeDeleteModal
  });

  const { action: onCancel } = useActionHook(cancelAction || defaultAction, {
    onFinally: closeDeleteModal
  });

  return (
    <Modal open={!!data} onClose={closeDeleteModal}>
      <Box sx={style}>
        <div className="delete-modal flex-col-sb-st">
          <header className="flex-row-sb-fc">
            <span> {element ? element : "Delete"}</span>
            <IconButton onClick={closeDeleteModal}>
              <CloseIcon className="delete-modal__icon" />
            </IconButton>
          </header>
          {Body ? (
            <Body />
          ) : (
            <div className="body">
              <span>{message ? message : "Are you sure you want to delete?"}</span>
            </div>
          )}
          <footer className="flex-row-fe-fc">
            <Button isLoading={loading} onClick={onCancel} variant="light" title={onPressCancel || "Cancel"} />
            <Button
              className="folder-create__submit"
              title={onPressSuccess || "Delete"}
              isLoading={loading}
              onClick={action}
            />
          </footer>
        </div>
      </Box>
    </Modal>
  );
};
